export const SET_STUDENT = "SET_STUDENT";
export const SIGN_OUT_STUDENT = "SIGN_OUT_STUDENT";
export const GET_STUDENT = "GET_STUDENT";
